export default "__VITE_ASSET__CoaaU6aK__"